import typeCheck from 'common/util/typeCheck';

/**
 * Creates a new array with reordered array elements.
 *
 * @param  {Array}  array     Array to reorder.
 * @param  {number} fromIndex Move array element from this index.
 * @param  {number} toIndex   Move array element to this index.
 * @return {Array}            New array with reordered elements.
 */
export default function reorderArrayElement(array, fromIndex, toIndex) {
  typeCheck('array::Array', array);
  typeCheck('fromIndex::Number', fromIndex);
  typeCheck('toIndex::Number', toIndex);

  const arrayClone = array.slice(0);
  arrayClone.splice(toIndex, 0, arrayClone.splice(fromIndex, 1)[0]);
  return arrayClone;
}
